import { Checkbox, NumericInput, TextInput } from 'Components/Core';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetBalanceFieldSet } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import QestIds from 'Components/Worksheets/QestIds';
import { ISieveSize } from 'Data/ViewModels/Equipment/ISieveSize';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';

let AsOversizeCorrectionSampleMassSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const mddTrayUsed = useSelector(createWorksheetSelector!('OversizeCorrectionData.TrayUsedFromMDD')) as boolean;
  const sieveSize = useSelector(createWorksheetSelector!('FieldResults.OversizeSieveSize')) as ISieveSize;
  const externalMddUsed = useSelector(
    pipe(createWorksheetSelector!('FieldResults.AssociatedCompactionData.AssociatedTestType'), (t) => t === 'external')
  );
  const AssignedValuesTestImported = useSelector(
    pipe(
      createWorksheetSelector!('FieldResults.AssociatedCompactionData.ImportedTest.Type.Id'),
      (t) => t === QestIds.assignedMaximumDryDensity.AS_1289_5_4_2.assignedValueTest
    )
  );
  const ExternalOrAssignedValueTestImported = externalMddUsed || AssignedValuesTestImported;
  return (
    <>
      <Field
        input={<Checkbox />}
        name="OversizeCorrectionData.TrayUsedFromMDD"
        visible={!ExternalOrAssignedValueTestImported}
      />
      <ListFieldSection>
        <WorksheetBalanceFieldSet
          name="OversizeCorrectionData.Balance"
          label="Balance"
          disabled={!externalMddUsed && mddTrayUsed}
        />
      </ListFieldSection>
      <ListFieldSection>
        {mddTrayUsed ? (
          <Field
            input={<TextOutput />}
            name="OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.ContainerMass"
          />
        ) : (
          <>
            <Field
              input={<TextInput />}
              name="OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.ContainerLabel"
            />
            <Field
              input={<NumericInput />}
              name="OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.ContainerMass"
            />
          </>
        )}
        <Field
          input={<NumericInput />}
          name="OversizeCorrectionData.TareAndTotalSampleWetMass"
          visible={ExternalOrAssignedValueTestImported}
        />
        <Field input={<TextOutput />} name="OversizeCorrectionData.TotalSampleWetMass" />
        <Field
          input={<TextOutput />}
          name="OversizeCorrectionData.OversizeSieveApertureSize"
          value={sieveSize?.Caption}
        />
        <Field
          input={<NumericInput />}
          name="OversizeCorrectionData.OversizeCorrectionConstantDryMass.DryingTray.WetSoilAndContainerMass"
          visible={ExternalOrAssignedValueTestImported}
        />
        <Field input={<TextOutput />} name="OversizeCorrectionData.OversizeMaterialWetMass" />
      </ListFieldSection>
    </>
  );
};

AsOversizeCorrectionSampleMassSection = withInjectedProps(AsOversizeCorrectionSampleMassSection);

export { AsOversizeCorrectionSampleMassSection };
export default AsOversizeCorrectionSampleMassSection;
